export default __webpack_public_path__ + "static/face_2-30491b2f36c319d5120a57311308686c.jpg";